<template>
    <vue-modal-custom
        v-model="isVisible"
        :header="false"
        :footer="false"
        :backdrop="false"
        :keyboard="false"
        :modalBodyClass="$prefixClass.modal + '-trouble-with-theme'"
    >
        <h4 class="m-b-16">{{ $t('optimize_image.components.trouble_with_theme') }}</h4>
        <span v-html="$t('optimize_image.components.trouble_with_theme_description')"></span>
        <div class="actions m-t-24">
            <a-button type="primary" @click="contactSupport"> {{ $t('optimize_image.buttons.contact_support') }}</a-button><br>
            <a-button class="m-t-8 text-color-secondary" type="subtle" @click="removeCode"> {{ $t('optimize_image.buttons.remove_our_code') }} </a-button>
        </div>
    </vue-modal-custom>
</template>
<script>
import VueModalCustom from '../../../components/VueModalCustom.vue'
export default {
  components: { VueModalCustom },
    name: 'ModalTroubleWithTheme',
    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isVisible: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        }
    },
    created() {
    },
    methods: {
        contactSupport() {
            this.isVisible = false
            this.$emit('contactForHelp')
        },
        removeCode() {
            this.isVisible = false
            this.$emit('onRemoveCode')
        }
    }
}
</script>
<style lang="scss">
    .m-modal-trouble-with-theme {
        width: 512px;
        text-align: center;
        .m-modal {
            &-body {
                padding: 40px;
                .#{$btn} {
                    width: 182px;
                    height: 40px;
                }
            }
            &-content {
                border-radius: 8px;
            }
        }
    }
</style>